export const home = {
  hero: {
    title: "Halal Investment Platform for Stocks",
    subtitle:
      "Screen, analyze and track global stocks based on transparent Islamic financial criteria.",
    searchPlaceholder: "Search",
  },
  promo: {
    regionLabel: "Promotional banners",
    slide1Headline: "Use the app for halal stock screening anytime",
    slide2Headline: "Instantly check the halal status of 16 000+ Stocks & ETFs",
    ctaCheckHalal: "Check Halal Stocks",
    slidesAria: "Banner slides",
    goToSlide: "Go to slide {{n}}",
    appStoreAria: "Download on the App Store",
    playStoreAria: "Get it on Google Play",
  },
  brokers: {
    label: "Trusted Brokers",
  },
  features: {
    learnMore: "Learn More",
    halalAnalysis: {
      title: "Halal Stocks Analysis",
      body: "Analyze halal stocks with transparent Islamic screening criteria. Review business activity, financial ratios, and compliance status in one place to make informed Shariah-compliant investment decisions.",
      imageAlt: "Halal stocks analysis preview",
    },
    topHalal: {
      title: "Top Halal Stocks",
      body: "Discover top halal stocks with quick access to Shariah-compliant stock screening, market insights, and simplified analysis. Find new investment opportunities based on transparent Islamic financial criteria.",
      imageAlt: "Top halal stocks preview",
    },
    myPortfolio: {
      title: "MyPortfolio",
      body: "Track your halal investment portfolio in one dashboard. Monitor holdings, follow compliance updates, and manage your stocks with clear portfolio insights designed for long-term halal investing.",
      imageAlt: "My Portfolio 2025 dashboard preview",
    },
    akindaAi: {
      title: "Akinda AI",
      body: "Upload any stock chart and get instant AI-powered analysis with technical indicators, trend detection, and actionable insights in seconds.",
      imageAlt: "Akinda AI preview",
    },
  },
  media: {
    badge: "Featured In",
    heading: "Recognized by leading financial media.",
    yahoo: "Yahoo Finance",
    globe: "The Globe and Mail",
    digitalJournal: "Digital Journal",
    businessWire: "Business Wire",
    barchart: "Barchart",
    halalWallet: "HalalWallet",
    independentReview: "Independently reviewed on",
  },
  faq: {
    title: "Frequently asked questions",
    subtitle: "Everything you need to know about the product and billing.",
    trustLine:
      "Don't just take our word for it. Our Shariah oversight and screening methodology are independently reviewed on {{halalWalletLink}}, the independent comparison platform for halal investing in the US.",
    trustAria: "Independent review",
    fallbackSupport:
      "Please contact support for details on this topic.",
    q1: {
      q: "What is halal investing?",
      a: "Halal investing is a form of investing that is compliant with Islamic law. It is based on the principles of Sharia law, which prohibits interest-based investments and certain types of trading. Halal investing is a way to invest in a way that is consistent with Islamic principles and values.",
    },
    q2: {
      q: "How does Akinda screen stocks for Shariah compliance?",
      a: "Akinda uses AAOIFI-based screening standards to analyze every stock's business activity, debt-to-equity ratio, and interest income. Non-compliant stocks are automatically filtered out before they reach you.",
    },
    q3: {
      q: "Is investing in the stock market halal or haram?",
      a: "Investing in the stock market is halal. However, not all stocks are halal. Akinda screens stocks for Shariah compliance before they are added to the platform.",
    },
    q4: {
      q: "How is Akinda different from Musaffa or Zoya?",
      a: "Akinda combines Shariah screening, real brokerage trading, portfolio journaling, and halal investing education in one platform — so you can screen, learn, and invest without switching between multiple apps.",
    },
    q5: {
      q: "Can beginners start halal investing with Akinda?",
      a: "Yes. Akinda is built for beginners and experienced investors alike, with step-by-step guides, educational content, and a simple interface to help you start investing in halal stocks confidently.",
    },
    q6: {
      q: "What are the best halal stocks and ETFs to invest in?",
      a: "Popular Shariah-compliant options include tech leaders like Apple, Google, and NVIDIA, and halal ETFs like SPUS and HLAL. Akinda's screener helps you discover compliant stocks across all sectors.",
    },
    q7: {
      q: "Which countries can use Akinda?",
      a: "Akinda is available to investors globally. We support account opening for residents of most countries, with more regions being added regularly.",
    },
    q8: {
      q: "Is my money and data safe with Akinda?",
      a: "Yes. Akinda partners with SEC-regulated broker-dealers, and your investments are protected by SIPC insurance. Your personal data is encrypted and never shared with third parties.",
    },
    q9: {
      q: "How do I contact Akinda support?",
      a: "You can contact Akinda support by clicking the 'Support' button on the Akinda website and filling out the contact form. You can also email us at contact@akinda.io.",
    },
  },
  footer: {
    tagline:
      "Screen, analyze and track global stocks based on transparent Islamic financial criteria.",
    navAria: "Footer navigation",
    getApp: "Get the app",
    appStoreAlt: "Download on the App Store",
    playStoreAlt: "Get it on Google Play",
    logoAlt: "Akinda",
    aboutUs: "About us",
    aboutFounder: "About founder",
    ourMission: "Our mission",
    forBusiness: "For business",
    mcp: "MCP Server",
    startups: "Startups",
    referral: "Referral",
    stockScreener: "Stock screener",
    etfScreener: "ETF screener",
    contactUs: "Contact us",
    screeningMethodology: "Our Screening Methodology",
    privacyPolicy: "Privacy policy",
    termsAndConditions: "Terms & conditions",
    disclosures: "Disclosures",
    socialLinkedin: "LinkedIn",
    socialInstagram: "Instagram",
    socialTelegram: "Telegram",
    riskDisclaimer:
      "All investments involve risk, including the potential loss of principal. The value of securities and other investments may fluctuate due to market conditions, economic factors, or other external influences, and past performance is not indicative of future results. The materials, data, and information made available on the Platform are provided solely for general informational and educational purposes and shall not be construed as investment advice, a recommendation to buy or sell any security, or a solicitation to engage in any transaction. Users are solely responsible for their investment decisions and are strongly encouraged to seek independent legal, financial, and tax advice before making any investment.",
    accuracyDisclaimer:
      "Akinda does not guarantee the accuracy, timeliness, or completeness of any information made available on the Platform. Information is subject to change without notice. Reasonable efforts are made to maintain the integrity of the content; however, Akinda assumes no responsibility for errors, misprints, or out-of-date information provided on the Platform. The Platform may include data, products, services, or other content provided by third-party sources. Akinda does not control or assume responsibility for any third-party content. All products, services, and content obtained from third-party content are provided \"as is\" without warranty of any kind, express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, title, non-infringement, security, or accuracy.",
    termsCaps:
      "PLEASE READ THIS FULL DISCLOSURE CAREFULLY BEFORE USING THIS SERVICE. BY USING THE SERVICE OR CLICKING AGREE, YOU ARE AGREEING TO BE BOUND BY THESE DISCLOSURES AND ALL TERMS AND CONDITIONS ON THIS WEBSITE/PLATFORM.",
    trademarks:
      "All trademarks, service marks, trade names, and logos displayed on the Platform are the property of their respective owners. References to third-party products, services, or providers do not constitute endorsement or recommendation by Akinda.",
    companyLine:
      "Akinda is owned and operated by Akinda Capital Technologies LLC registered in Dover, Delaware, United States.",
    visitDisclosures:
      "Please visit our <disclosuresLink>Disclosures Page</disclosuresLink> for further information.",
    copyright: "© {{year}} Akinda. All rights reserved.",
  },
} as const;
